import React, { FC } from 'react';
import { Dialog } from 'primereact/dialog';
import './UnitDetailModal.style.scss';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    driverPhoto: string;
    unitPhoto: string;
    driver: string;
    unit: string;
}

const UnitDetailModal: FC<ModalProps> = ({ isOpen, onClose, driverPhoto, unitPhoto, driver, unit}) => {
    return (
        <Dialog
            visible={isOpen}
            onHide={onClose}
            header="Detalle de la unidad"
            dismissableMask
            className="unit-detail-dialog"
        >
            <div className="unit-detail-body">
                <div className="unit-detail-item">
                    <img src={driverPhoto} alt="Operador" className="unit-detail-photo" />
                    <h3 className="unit-detail-name">{driver}</h3>
                </div>
                <div className="unit-detail-item">
                    <img src={unitPhoto} alt="Unidad" className="unit-detail-photo" />
                    <h3 className="unit-detail-name">{unit}</h3>
                </div>
            </div>
        </Dialog>
    );
};

export default UnitDetailModal;
